/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/rightarrowactive.png';
import _imports_1 from '@/assets/duihao.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-02b2f172"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "w100% color-#121212 mt-120px"
};
var _hoisted_2 = {
  "class": "font-size-28px font-600"
};
var _hoisted_3 = {
  "class": "color-#225eef mr-10px"
};
var _hoisted_4 = {
  "class": "color-#121212"
};
var _hoisted_5 = {
  "class": "flex flex-items-center subtitle mt-10px"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "了解详情", -1);
});
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    "class": "h-20px w-auto"
  }, null, -1);
});
var _hoisted_8 = [_hoisted_6, _hoisted_7];
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "divider pos-relative"
  }, [/*#__PURE__*/_createElementVNode("div", {
    "class": "w-26px h-3px bg-black pos-absolute left-0 bottom-0"
  })], -1);
});
var _hoisted_10 = {
  "class": "flex"
};
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    "class": "h22px w-auto mr-10px"
  }, null, -1);
});
var _hoisted_12 = {
  "class": "color-#333333"
};
var _hoisted_13 = ["src"];
export default {
  __name: 'indexProjectSpecial',
  props: {
    item: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    num: {
      type: Number,
      "default": 0
    }
  },
  emits: ['handleClick'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var _toRefs = toRefs(props),
      item = _toRefs.item,
      num = _toRefs.num;
    var emit = __emit;
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, "0" + _toDisplayString(_unref(num)), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(item).title), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(_unref(item).subtitle), 1), _createElementVNode("div", {
        "class": "btn",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return emit('handleClick');
        })
      }, _hoisted_8)]), _hoisted_9, _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(item).introduction, function (v, i) {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          "class": _normalizeClass([i === 0 ? '' : 'ml-30px', "flex flex-items-center mt-15px"])
        }, [_hoisted_11, _createElementVNode("span", _hoisted_12, _toDisplayString(v), 1)], 2);
      }), 128))]), _createElementVNode("img", {
        src: _unref(item).img[0],
        "class": "w-100% h-auto mt-50px"
      }, null, 8, _hoisted_13)]);
    };
  }
};